import React from "react";

const TransmissionSVG: React.FunctionComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect width="24" height="24" rx="12" fill="#E5E8E9" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.75 7a1.25 1.25 0 0 0-.625 2.331v2.044h-2.5V9.331a1.254 1.254 0 0 0 .625-1.081 1.25 1.25 0 1 0-1.875 1.081v2.044h-2.5V9.331A1.249 1.249 0 0 0 8.25 7a1.25 1.25 0 0 0-.625 2.331v5.338a1.249 1.249 0 0 0 .625 2.33 1.25 1.25 0 0 0 .625-2.33v-2.044h2.5v2.044A1.249 1.249 0 0 0 12 17a1.25 1.25 0 0 0 .625-2.331v-2.044h3.125c.345 0 .625-.28.625-.625V9.331A1.248 1.248 0 0 0 15.75 7"
      fill="#1D2948"
    />
  </svg>
);

export default TransmissionSVG;
